<template>
  <div class="settings-wrapper" :style="header ? 'height: calc(100% - 70px);' : 'height: 100%;'">
    <div class="settings-header" v-if="header">
      <slot name="header"></slot>
    </div>
    <div class="options-list">
      <slot name="options-list"></slot>
    </div>
    <div class="arrow-wrapper" v-if="arrow">
      <div class="arrow-down-list"></div>
    </div>
    <slot name="alert"></slot>
    <slot name="empty"></slot>
  </div>
</template>

<script>
const name = 'opti_select'

const props = {
  header: {
    type: Boolean,
    required: false,
    default: false
  },
  alert: {
    type: Boolean,
    required: false,
    default: false
  },
  arrow: {
    type: Boolean,
    default: false,
    required: false
  }
}

export default {
  name,
  props
}
</script>

<style>
  .settings-wrapper {
    position: relative;
    width: 100%;
    min-height: 300px;
    background-color: rgba(250, 250, 250, 1);
  }

  .settings-header {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 0 20px 20px 20px;
    background-color: #F5F5F5;
  }

  .options-list {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    margin-bottom: 6px;
    z-index: 210;
    background-color: #f5f5f5;
    -webkit-overflow-scrolling: touch;
  }

  .arrow-wrapper {
    position: absolute;
    bottom: -18px;
    right: -14px;
    z-index: 200;
  }

  .arrow-down-list {
    width: 90px;
    height: 18px;
    position: relative;
    overflow: hidden;
    -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
            transform: rotate(180deg);
    -webkit-box-shadow: 0 16px 10px -17px rgba(0, 0, 0, 0.5);
            box-shadow: 0 16px 10px -17px rgba(0, 0, 0, 0.5);
  }

  .arrow-down-list:after {
    content: "";
    position: absolute;
    width: 50px;
    height: 50px;
    background: rgba(250, 250, 250, 1);
    -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
            transform: rotate(45deg); /* Prefixes... */
    left: 0;
    right: 0;
    top: 10px;
    margin-left: auto;
    margin-right: auto;
    -webkit-box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
            box-shadow: -1px -1px 10px -2px rgba(0, 0, 0, 0.5);
  }

  @media only screen and (max-width: 960px) {
    .settings-wrapper {
      height: calc(100% - 40px);
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/optimus/OptiSelect.vue